<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo" style="font-size: 1em">
        <!--        <vuexy-logo />-->
        <span class="brand-logo">
          <b-img :src="appLogoImage" alt="logo" style="width: 200px" />
        </span>
        <!--        <h2 class="brand-text text-primary ml-1">MOM HIS</h2>-->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex flex-column align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col sm="2" md="2" lg="2" class="px-xl-2 ml-auto">
          <locale />
        </b-col>
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            {{ $t("auth.loginTitle") }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t("auth.enterInformation") }}
          </b-card-text>

          <!-- form -->
          <!-- <validation-observer ref="loginValidation"> -->
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- usenrame -->
            <b-form-group
              :label="$t('auth.username')"
              label-for="login-username"
              :invalid-feedback="
                invalidFeedbackUsername
                  ? $t(`validation.${invalidFeedbackUsername}`, {
                      field: $t('auth.username'),
                    })
                  : ''
              "
              :state="$v.username.$dirty ? !$v.username.$invalid : null"
            >
              <b-form-input
                id="login-username"
                v-model="username"
                name="login-username"
                :state="$v.username.$dirty ? !$v.username.$invalid : null"
              />
            </b-form-group>

            <!-- forgot password -->
            <b-form-group
              :invalid-feedback="
                invalidFeedbackPassword
                  ? $t(`validation.${invalidFeedbackPassword}`, {
                      field: $t('auth.password'),
                    })
                  : ''
              "
              :state="$v.password.$dirty ? !$v.password.$invalid : null"
            >
              <div class="d-flex justify-content-between">
                <label for="login-password">{{ $t("auth.password") }}</label>
                <b-link :to="{ name: 'auth-forgot-password-v2' }">
                  <!--                  <small>{{ $t("auth.forgetPassword") }}</small>-->
                </b-link>
              </div>
              <!-- <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                > -->
              <b-input-group
                :state="$v.password.$dirty ? !$v.password.$invalid : null"
                class="input-group-merge"
              >
                <b-form-input
                  :state="$v.password.$dirty ? !$v.password.$invalid : null"
                  id="login-password"
                  v-model="password"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="login-password"
                  placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <!-- <small class="text-danger">{{ errors[0] }}</small> -->
              <!-- </validation-provider> -->
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
                class="login-users"
              >
                {{ $t("auth.rememberMe") }}
              </b-form-checkbox>
            </b-form-group>

            <!-- submit buttons -->
            <b-button type="submit" variant="primary" block @click="login">
              {{ $t("auth.login") }}
            </b-button>
          </b-form>
          <!-- </validation-observer> -->

          <!--          <b-card-text class="text-center mt-2">-->
          <!--            <span>{{ $t("auth.newUser") }}</span>-->
          <!--            <b-link :to="{ name: 'page-auth-register-v2' }">-->
          <!--              <span>&nbsp;{{ $t("auth.createAnAccount") }}</span>-->
          <!--            </b-link>-->
          <!--          </b-card-text>-->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { required } from "vuelidate/lib/validators";
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
} from "bootstrap-vue";
import locale from "@/layouts/app-navbar/components/Locale";
// import { required, email } from '@validations'
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { $themeConfig } from "@themeConfig";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    locale,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      username: "",
      sideImg: require("@/assets/images/pages/momturn.jpg"),
      // validation rulesimport store from '@/store/index'
      // required,
      // email,
    };
  },
  mounted() {
    this.$store.commit('SET_IS_LOADING', false)
  },
  computed: {
    invalidFeedbackUsername: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.username.$dirty) return error;
        if (!this.$v.username.required) error = "required";
        return error;
      },
    },
    invalidFeedbackPassword: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.password.$dirty) return error;
        if (!this.$v.password.required) error = "required";
        return error;
      },
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/momturn.jpg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    login() {
      // this.$refs.loginValidation.validate().then((success) => {
      //   if (success) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          // checkbox_remember_me: this.checkbox_remember_me,
          // userDetails: {
          username: this.username,
          password: this.password,
          // }
        };

        this.$store
          .dispatch("auth/login", payload)
          .then((res) => {
            // if (this.$cookies.get('token').length) {
            if (localStorage.getItem("token").length) {
              this.$router.push({ name: "home" });
              this.$ability.update(
                JSON.parse(localStorage.getItem("abilityData"))
              );
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 401) {
              this.$bvToast.toast(
                this.$t("toastification.usernameOrPasswordIsWrong"),
                {
                  title: this.$t("toastification.errorOccurred"),
                  variant: "danger",
                  solid: true,
                }
              );
            }
          });
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: this.$t("error.submission"),
        //     icon: "EditIcon",
        //     variant: "error",
        //   },
        // });
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Form Submitted',
        //     icon: 'EditIcon',
        //     variant: 'success',
        //   },
        // })
      } else {
        this.$nextTick(() => {
          const el = document.querySelector(".is-invalid:first-of-type");
          
          el.scrollIntoView({ behavior: "instant", block: "center" });
          // el.scrollIntoView();
          return;
        });
      }
    },
  },
  validations() {
    return {
      username: {
        required,
      },
      password: {
        required,
      },
    };
  },
  setup(props) {
    // App Name
    const { appLogoImage } = $themeConfig.app;

    return {
      // App Name
      appLogoImage,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
